import store from 'app/store';

import { selectAuthToken } from 'features/auth/authSelectors';

import { isHttpUrl } from 'utils/urlUtils';

import { resolveMainApiHost } from './api';
import isS3SignedUrl from './isS3SignedUrl';

const fetchTextWithAuth = async (url: string): Promise<string> => {
  const raw = (url || '').trim();
  if (!raw) {
    throw new Error('URL is empty');
  }

  if (isS3SignedUrl(raw)) {
    return raw;
  }

  const token = selectAuthToken(store.getState());
  const headers: HeadersInit = {};

  if (token) {
    headers.Authorization = token;
  }

  // If caller passes relative path, build full URL based on main API host (region-aware).
  // IMPORTANT: use URL() instead of string concat to avoid path duplication like `/v1/v1/...`.
  const requestUrl = isHttpUrl(raw)
    ? raw
    : new URL(raw, resolveMainApiHost()).toString();

  const res = await fetch(requestUrl, { method: 'GET', headers });
  if (!res.ok) {
    throw new Error(`Failed to fetch text: ${res.status}`);
  }

  const text = (await res.text()).trim();
  try {
    const parsed = JSON.parse(text);
    if (typeof parsed === 'string') {
      return parsed.trim();
    }
  } catch {}

  // Fallback: strip wrapping quotes if present.
  if (
    (text.startsWith('"') && text.endsWith('"')) ||
    (text.startsWith("'") && text.endsWith("'"))
  ) {
    return text.slice(1, -1).trim();
  }

  return text;
};

export default fetchTextWithAuth;
